import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e55f105"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col flex-grow-1 option-card-container" }
const _hoisted_2 = { class: "card card--options" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "list-group list-group-flush option-list" }
const _hoisted_6 = { class: "form-check option__input" }
const _hoisted_7 = ["id", "checked", "disabled", "onChange"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { class: "option__title" }
const _hoisted_10 = {
  key: 0,
  class: "option__info"
}
const _hoisted_11 = ["data-bs-content"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  "aria-label": "Weitere Information",
  class: "fal far fas fa-question-circle info-icon"
}, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "option__price"
}
const _hoisted_15 = {
  key: 2,
  class: "text-info option__preselected"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_image_top = _resolveComponent("card-image-top")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.optionGroup.image)
        ? (_openBlock(), _createBlock(_component_card_image_top, {
            key: 0,
            image: _ctx.optionGroup.image
          }, null, 8, ["image"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.htmlDecode(_ctx.optionGroup.title)), 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionGroupOptions, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            key: option.id,
            class: "list-group-item option-list__item list-item option"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("input", {
                id: `option-${option.id}-selected`,
                checked: option.isSelected || option.isPreSelected,
                disabled: option.isPreSelected,
                class: "form-check-input",
                type: "checkbox",
                onChange: ($event: any) => (_ctx.onOptionSelectionChanged($event, option))
              }, null, 40, _hoisted_7),
              _createElementVNode("label", {
                for: `option-${option.id}-selected`,
                class: "form-check-label option__label"
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.htmlDecode(option.title)), 1)
              ], 8, _hoisted_8)
            ]),
            (option.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    "data-bs-content": _ctx.htmlDecode(option.description),
                    "data-bs-toggle": "popover",
                    href: "#",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"]))
                  }, _hoisted_13, 8, _hoisted_11)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showPrice && option.price && !option.isPreSelected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.getOptionPriceForDisplay(option)), 1))
              : _createCommentVNode("", true),
            (option.isPreSelected)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.htmlDecode(_ctx.getPreSelectedOptionText(option))), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ])
  ]))
}